<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Activités de l'officine (1/4)">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; La pharmacie est-elle intégrée dans une Maison de Santé
                Pluriprofessionnelle (MSP), dans une Communauté Professionnelle
                Territoriale de Santé (CPTS) ou un réseau de soins ?
              </span>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group
                    v-model="dossier.mspIntegration"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="mspIntegration"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="mspIntegration"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="dossier.mspIntegration">
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="dossier.mspPrecision"
                    label="Si oui, indiquez laquelle/lequel :"
                    required
                    :rules="textRules"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Exercice Officinal
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8">
              <p class="subtitle-1 text-left">
                &#187; La dispensation s'accompagne-t-elle d'une inscription au
                DP ?
                <v-row>
                  <v-col cols="12" md="6">
                    <v-radio-group
                      v-model="dossier.dppDispensationInscription"
                      required
                      :rules="radioRules"
                    >
                      <v-radio
                        label="Oui systématiquement en accord avec le patient"
                        name="dppDispensationInscription"
                        value="Oui systématiquement en accord avec le patient"
                        required
                      ></v-radio>
                      <v-radio
                        label="Oui de temps en temps en accord avec le patient"
                        name="dppDispensationInscription"
                        value="Oui de temps en temps en accord avec le patient"
                        required
                      ></v-radio>
                      <v-radio
                        label="Non"
                        name="dppDispensationInscription"
                        value="Non"
                        required
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Consultez-vous le Dossier Pharmaceutique des patients ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.dppConsultation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="dppConsultation"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="dppConsultation"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie8",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"]
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!this.dossier.mspIntegration) this.dossier.mspPrecision = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
